/* eslint-disable @typescript-eslint/no-explicit-any */
import Button from './Button';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { teamProfileGet } from '../../../modules/sport/actions/reducerTeam';
import { ITeam } from '../../../modules/sport/interfaces/game';
//ball
import BalonFutbol from '../../../common/components/images/sports/futbol/balonNav.svg';
import BalonTenis from '../../../common/components/images/sports/tenis/balonNav.svg';
import BalonPadel from '../../../common/components/images/sports/padel/balonNav.svg';
import BalonBasquetbol from '../../../common/components/images/sports/basquetbol/balonNav.svg';
import TeamBySport from './TeamBySport';
import { getUserProfile, updateUserProfile } from '../../../modules/sport/actions/reducerProfile';

const iconBall = {
    tenis: BalonTenis,
    futbol: BalonFutbol,
    padel: BalonPadel,
    basquetbol: BalonBasquetbol,
};

const resetError = {
    name: {
        hasError: false,
        message: '',
    },
    review: {
        hasError: false,
        message: '',
    },
    gender: {
        hasError: false,
        message: '',
    },
    level: {
        hasError: false,
        message: '',
    },
    color: {
        hasError: false,
        message: '',
    },
    color2: {
        hasError: false,
        message: '',
    },
};

const FormCreateTeam = (props: any): JSX.Element => {
    const { setOpenModalTeam, setdataTeamOri, sport, team } = props;
    const dispatch = useDispatch();
    const selectProfile = (state: any) => state.profile;
    const [error, setError] = useState('');
    const stateProfile = useSelector(selectProfile);
    const [teams, setTeams] = useState<ITeam[]>([]);
    const [teamsAux, setTeamsAux] = useState<ITeam[]>([]);
    const [teamsProfile, setTeamsProfile] = useState<ITeam[]>([]);
    const urlFile = process.env.REACT_APP_URL_FILE;
    const [errorTeam, setErrorTeam] = useState(resetError);
    const [update, setUpdate] = useState<boolean>(false);
    const [profile, setProfile] = useState({
        name: '',
        lastName: '',
        phone: '',
        gender: '',
        birthDate: '',
        address: '',
        regionId: '',
        countyId: '',
        position: '',
        photo: '',
    });

    useEffect(() => {
        if (teamsAux) {
            //console.log('useEffect teamsAux externo:', teamsAux);
        }
    }, [teamsAux]);

    useEffect(() => {
        if (team) {
            //console.log({ team });
            if (team.error) {
                setError('Error al obtener el Equipo del usuario');
            } else {
                if (team.data && team.data.data && team.data.statusCode === 'USER_PROFILE_TEAM_GETED') {
                    const dataTeam = team.data.data;
                    setdataTeamOri(dataTeam);
                    //aqui valido si updateTeamProfile viene en falso no tiene nombre de equipo, se activa el formulario para crearlo
                    if (!dataTeam.updatedTeamProfile) {
                        const newTeam = {
                            color: dataTeam.color,
                            color2: dataTeam.color2,
                            id: dataTeam.id,
                            imagePath: dataTeam.logo || '',
                            name: dataTeam.name,
                            photo: dataTeam.photo,
                            review: dataTeam.review,
                            sportName: dataTeam.sport?.name,
                            sportSlug: dataTeam.sport?.slugName,
                        };
                        setTeams([newTeam]);
                        setOpenModalTeam(true);
                    } else {
                        setOpenModalTeam(false);
                    }
                }
            }
        }
    }, [team]);

    useEffect(() => {
        //mapeo el estado de perfil del usuario para obtener los datos y poder enviarlo al actualizar
        if (stateProfile && stateProfile.data?.statusCode === 'USER_PROFILE_UPDATED') {
            setUpdate(true);
        } else {
            if (stateProfile && stateProfile.data && stateProfile.data.data) {
                const data = stateProfile.data.data;
                setUpdate(false);
                setProfile({
                    name: data.name,
                    lastName: data.lastName,
                    phone: data.phone,
                    gender: data.gender,
                    birthDate: data.birthDate,
                    address: data.address,
                    regionId: data.regionId,
                    countyId: data.countyId,
                    position: data.position,
                    photo: data.photo,
                });
                setTeamsProfile(data.teams);
            }
        }
    }, [stateProfile]);

    useEffect(() => {
        dispatch(teamProfileGet(sport));
        dispatch(getUserProfile());
    }, []);

    useEffect(() => {
        if (update) {
            dispatch(teamProfileGet(sport));
        }
    }, [update]);

    const handlerSaveSport = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        console.log('aqui guardar perfil', teams && teams, teamsProfile && teamsProfile);
        //Setear por defecto la imagen del equipo cuando es undefined
        const teamWithImage = {
            ...teams[0],
            photo:
                !teams[0]['photo'] &&
                teams[0]['photo'] === undefined &&
                !teams[0]['imagePath'] &&
                teams[0]['imagePath'] === ''
                    ? '54a65481-9511-470b-9ce4-fe34fd749ccd.png'
                    : teams[0]['photo'],
        };
        const teamAux = teamWithImage;
        const teamsProfileAux = teamsProfile;
        if (teamsProfile && teamsProfile.length > 0) {
            const indexTeams = teamsProfile.findIndex((t) => t.id === teamAux.id);
            //console.log({ indexTeams });
            teamsProfileAux[indexTeams] = teamAux;
        }

        if (teamAux && (!teamAux['level'] || teamAux['level'] === '')) {
            setErrorTeam({
                ...errorTeam,
                level: {
                    hasError: true,
                    message: 'Nivel del equipo requerido!',
                },
            });
        }
        if (teamAux && (!teamAux['gender'] || teamAux['gender'] === '')) {
            setErrorTeam({
                ...errorTeam,
                gender: {
                    hasError: true,
                    message: 'Sexo del equipo requerido!',
                },
            });
        }
        if (teamAux && (!teamAux['color2'] || teamAux['color2'] === '')) {
            setErrorTeam({
                ...errorTeam,
                color2: {
                    hasError: true,
                    message: 'Color del equipo visitante requerido!',
                },
            });
        }
        if (teamAux && (!teamAux['color'] || teamAux['color'] === '')) {
            setErrorTeam({
                ...errorTeam,
                color: {
                    hasError: true,
                    message: 'Color del equipo local requerido!',
                },
            });
        }
        if (teamAux && teamAux.review === '') {
            setErrorTeam({
                ...errorTeam,
                review: {
                    hasError: true,
                    message: 'Descripción breve del equipo requerido!',
                },
            });
        }
        if (teamAux && teamAux.name === '') {
            setErrorTeam({
                ...errorTeam,
                name: {
                    hasError: true,
                    message: 'Nombre del equipo requerido!',
                },
            });
        }
        if (
            teamAux.review !== '' &&
            teamAux.name !== '' &&
            teamAux['gender'] &&
            teamAux['gender'] !== '' &&
            teamAux['level'] !== '' &&
            teamAux['level'] &&
            teamAux['color'] &&
            teamAux['color'] !== '' &&
            teamAux['color2'] &&
            teamAux['color2'] !== ''
        ) {
            dispatch(
                updateUserProfile({
                    ...profile,
                    teams: teamsProfileAux,
                }),
            );
        }
    };

    return (
        <section className="container w-full md:w-5/6     mx-auto py-4 md:py-6 md:px-16 border-2 bg-white shadow-lg rounded-xl">
            <div className="flex justify-center content-center   items-center">
                <h1 className="text-base md:text-2xl pt-10 font-bold text-sm-rent flex justify-center content-center   items-center px-4 md:px-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-12 md:h-20 w-12 md:w-20 fill-yellow-500 "
                        fill="none"
                        viewBox="0 0 28 28"
                        stroke="currentColor"
                    >
                        <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                    Debes Crear un Equipo de {sport} para crear este Desafío
                </h1>
            </div>
            <div className="flex justify-center mb-3 leading-normal">
                {teams &&
                    teams.length > 0 &&
                    teams.map((t, i) => (
                        <div key={`card-sport-profile-${i}`}>
                            <div
                                className="mx-auto md:mx-2 w-full bg-white flex flex-col justify-center items-center rounded-lg py-1 mb-1 md:mb-0 "
                                key={`cardProfile-${Math.random().toString(36).substr(2, 9)}-${i}`}
                            >
                                <TeamBySport
                                    teamOri={t}
                                    iconSport={iconBall[t.sportSlug]}
                                    index={i}
                                    urlFile={urlFile}
                                    setTeamsAux={setTeamsAux}
                                    teams={teams}
                                    error={errorTeam}
                                />
                            </div>
                        </div>
                    ))}
            </div>
            <footer className="flex justify-end align-center">
                <div className="flex flex-col mx-auto w-full md:w-1/3 mt-6 mb-2">
                    <Button title={'Guardar'} handlerClick={handlerSaveSport} />
                </div>
                {error && (
                    <div className="flex flex-col mx-auto w-full md:w-1/3 mt-6 mb-2">
                        <p className="w-full my-6 text-red-500">*{error}</p>
                    </div>
                )}
            </footer>
        </section>
    );
};

export default FormCreateTeam;
